<template>
  <span>
    <Circle :id="'colorpopover' + track.gpsTrack.id + type" :style="{ color: track.gpsTrack.color, height: height, width: width || null, cursor: 'pointer' }" />
    <b-popover ref="popover" :target="'colorpopover' + track.gpsTrack.id + type" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
      <template v-slot:title>{{ $t('changeColor') }}
        <div style="float: right;">
          <img @click="closePopover" style="height: 20px; cursor: pointer;" :src="icons.closeIcon" />
        </div>
      </template>
      <SketchPicker
        :presetColors="['#FF0000', '#09FF00', '#FF00E4', '#0037FF', '#00FFED', '#F6FF00', '#FFB600', '#007FFF', '#50006B', '#0C6E3D', '#9013FE', '#FE1378', '#511212', '#9B9B9B', '#FFFFFF', '#000000']"
        v-model="color" :disableAlpha="true" :disableFields="true"></SketchPicker>
    </b-popover>
  </span>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import Track from '@/ts/Track';
import { defineComponent, type PropType } from "vue";
import Circle from '@/components/icons/Circle.vue';

export default defineComponent({
  extends: BaseComponent,
  components: {
    Circle
  },
  data() {
    return {
      color: ''
    };
  },
  beforeCreate() {
    this.color = this.track.gpsTrack.color;
  },
  methods: {
    closePopover() {
      //@ts-ignore
      this.$refs.popover.hide();
    },
    onCheckedChanged(value: boolean, oldValue: boolean) {
      //@ts-ignore
      this.track.gpsTrack.color = this.color.hex;
    }
  },
  props: {
    track: {
      required: true,
      type: Object as PropType<Track>
    },
    type: {
      required: false,
      type: String
    },
    height: {
      required: false,
      type: String
    },
    width: {
      required: false,
      type: String
    }
  },
  watch: {
    "color": [{
      handler: "onCheckedChanged"
    }]
  }
})


</script>
